import { Box, CircularProgress, Grid, Theme, useTheme } from "@mui/material";
import { useIntl } from "react-intl";
import useGlobalContext from "globalProviders/GlobalDataProvider";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import BackLink from "components/BackLink";
import CourseDetailsCtas from "./CourseDetailsCtas";

const getStyles = (theme: Theme) => ({
  wrapper: {
    ".course-header": {
      alignItems: "start",
      ".course-header-content": {
        padding: 2,
        alignItems: "start",
        h1: {
          textAlign: "left",
        },
      },
    },
    ".course-body": {
      "> .row": {
        alignItems: "flex-start",
      },
      ".course-body-spacing-override": {
        [theme.breakpoints.up("lg")]: {
          mr: 2,
        },
      },
    },
  },
});

export default function CourseDetailsPage() {
  const { formatMessage: t } = useIntl();
  const styles = getStyles(useTheme());
  const { skuId } = useParams();
  const { courseService, coursesUrl } = useGlobalContext();
  const wrapperDiv = useRef<HTMLDivElement>(null);
  const [ctasContainer, setCtasContainer] = useState<Element | null>(null);

  const { data, isFetching } = useQuery(
    ["courseService.getCourseDetails", skuId],
    () => courseService.getCourseDetails(skuId!),
    { staleTime: 0 },
  );

  useEffect(() => {
    if (!wrapperDiv.current) return;

    const bodyRow = wrapperDiv.current.querySelector(".course-body > .row");

    if (!bodyRow) return;

    let ctasDiv = bodyRow.querySelector("#course-details-ctas");
    if (!ctasDiv) {
      ctasDiv = document.createElement("div");
      ctasDiv.id = "course-details-ctas";
      bodyRow.appendChild(ctasDiv);
    }

    setCtasContainer(ctasDiv);
  }, [data]);

  return (
    <>
      {isFetching ? (
        <Grid container justifyContent="center">
          <CircularProgress />
        </Grid>
      ) : (
        <>
          <Box display="flex" alignItems="center">
            <BackLink to={coursesUrl()} />
            <h3>{t({ id: "backToMyCourses" })}</h3>
          </Box>
          <Box
            sx={styles.wrapper}
            ref={wrapperDiv}
            dangerouslySetInnerHTML={{
              __html: data?.renderedTemplate ?? "",
            }}
          />
          {ctasContainer &&
            data?.model &&
            createPortal(
              <CourseDetailsCtas course={data.model} />,
              ctasContainer,
            )}
        </>
      )}
    </>
  );
}
